<template>
  <div>
    <advanced-table
      :headers="headers"
      :filters="filters"
      :sortBy="['imei']"
      :sortDesc="[false]"
      :resource="resource"
      :optionLists="optionLists"
    />
    <store-transfer-dialog :imei="clickedImei" />
  </div>
</template>

<script>
import AdvancedTable from "@/components/AdvancedTable.vue";
import StoreTransferDialog from "@/components/StoreTransferDialog";
// import { format } from "date-fns";

export default {
  data() {
    return {
      clickedImei: null,
      headers: [
        {
          text: "IMEI",
          value: "imei",
          align: "start",
          visible: true,
          width: "200",
          displayFunc: (data, key) => {
            return data[key] ? data[key] : "לא ידוע";
          },
          linkTo: item => {
            return `/devices/${item._id}`;
          }
        },

        {
          text: "חנות",
          value: "store",
          align: "start",
          visible: true,
          width: "200",
          displayFunc: (data, key) => {
            let store = this.entityById(
              "stores",
              data[key] ? data[key]._id || data[key] : null
            );
            return store ? store.title : "לא ידוע";
          }
        },
        {
          text: "מגירה",
          value: "boxType",
          align: "start",
          visible: true,
          width: "200",
          displayFunc: (data, key) => {
            let boxType = this.entityById(
              "boxTypes",
              data[key] ? data[key]._id || data[key] : null
            );
            return boxType ? boxType.title : "לא ידוע";
          }
        },
        {
          text: "סטאטוס תקשורת",
          value: "networkStatusType",
          align: "start",
          visible: true,
          width: "200",
          displayFunc: (data, key) => {
            let networkStatusType = this.entityById(
              "networkStatusTypes",
              data[key] ? data[key]._id || data[key] : null
            );
            return networkStatusType ? networkStatusType.title : "לא ידוע";
          }
        },      
        {
          text: "העברת חנות",
          type: "ACTION",
          value: "action",
          name: "storeTransfer",
          align: "start",
          visible: true,
          icon: "mdi-truck-delivery",
          sortable: false,
          click: deviceId => {
            let device = this.$store.state.entities.devices[deviceId];
            if (device) {
              this.clickedImei = device.imei;
              this.storeTransfer(device);
            }
            return Promise.resolve();
          }
        }
      ],
      filters: [
        {
          type: "COMBOBOX",
          label: "סוג",
          model: "types",
          items: "types",
          itemText: "title",
          itemValue: "_id",
          active: false
        },
        {
          type: "COMBOBOX",
          label: "חנות",
          model: "stores",
          items: "stores",
          itemText: "title",
          itemValue: "_id",
          active: true
        },
        {
          type: "COMBOBOX",
          label: "מגירה",
          model: "boxTypes",
          items: "boxTypes",
          itemText: "title",
          itemValue: "_id",
          active: true
        },        
        {
          type: "COMBOBOX",
          label: "סטאטוס תקשורת",
          model: "networkStatusTypes",
          items: "networkStatusTypes",
          itemText: "title",
          itemValue: "_id",
          active: true
        },
        {
          type: "BOOLEAN",
          label: "משויך להזמנה פעילה",
          model: "bookedOut",
          active: false
        },
        {
          type: "TEXT",
          label: "חיפוש חופשי",
          model: "search",
          icon: "mdi-magnify",
          expanded: true,
          active: true
        }
      ]
    };
  },
  computed: {
    devices() {
      return this.$store.getters["entityList"]("devices");
    },
    types() {
      return this.$store.getters["entityList"]("deviceTypes");
    },
    stores() {
      return this.$store.getters["entityList"]("stores");
    },
    boxTypes() {
      return this.$store.getters["entityList"]("boxTypes");
    },  
    networkStatusTypes() {
      return this.$store.getters["entityList"]("networkStatusTypes");
    }, 
    resource() {
      return this.$store.state.resources["device"];
    },
    optionLists() {
      return {
        types: this.types,
        stores: this.stores,
        boxTypes: this.boxTypes,
        networkStatusTypes: this.networkStatusTypes
      };
    },
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    },
    storeTransferDialog: {
      get() {
        return this.$store.state.storeTransferDialog;
      },
      set(isActive) {
        this.$store.commit("TOGGLE_STORE_TRANSFER_DIALOG", isActive);
      }
    }
  },
  methods: {
    entityById(entityType, id) {
      return this.$store.getters["entity"](entityType, id);
    },
    storeTransfer() {
      this.storeTransferDialog = true;
    }
  },

  watch: {
    storeTransferDialog: {
      handler: function(val) {
        if (!val) {
          this.clickedImei = null;
        }
      }
    }
  },

  components: {
    AdvancedTable,
    StoreTransferDialog
  }
};
</script>